import { jsx as _jsx } from "react/jsx-runtime";
import { BoxStyled } from './ToolbarBox.styled';
const ToolbarBox = (props) => {
    return _jsx(BoxStyled, { ...props });
};
export { ToolbarBox };
